import { render } from "./PasswordSelectForm.vue?vue&type=template&id=6c5e79ba"
import script from "./PasswordSelectForm.vue?vue&type=script&lang=js"
export * from "./PasswordSelectForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__